import { render, staticRenderFns } from "./form_table.vue?vue&type=template&id=0a70e14f"
import script from "./form_table.vue?vue&type=script&lang=js"
export * from "./form_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a70e14f')) {
      api.createRecord('0a70e14f', component.options)
    } else {
      api.reload('0a70e14f', component.options)
    }
    module.hot.accept("./form_table.vue?vue&type=template&id=0a70e14f", function () {
      api.rerender('0a70e14f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/form/components/form_table.vue"
export default component.exports